var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNj211(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a4c1d32a-c9dd-4ec6-9289-478619132adb",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400.7 245.9",
    style: {
      enableBackground: "new 0 0 400.7 245.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#788EC7;}\n\t.st2{fill:#F04E31;}\n\t.st3{fill:#FCB23D;}\n\t.st4{fill:#0056A7;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.3,70.7c-0.1-0.8-0.2-1.6-0.3-2.4C370.1,69.1,370.2,69.9,370.3,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.8,66.9c-0.1-0.7-0.2-1.5-0.4-2.2C369.5,65.4,369.6,66.1,369.8,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.2,59.5c-0.2-0.7-0.4-1.4-0.6-2.1C367.8,58.1,368,58.8,368.2,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.1,63.1c-0.1-0.7-0.3-1.4-0.5-2.1C368.8,61.7,368.9,62.4,369.1,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,138.3c-0.6-0.6-1.2-1.1-1.8-1.7C24.4,137.2,25,137.7,25.6,138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,135.7c-0.6-0.6-1.2-1.2-1.8-1.8C21.8,134.5,22.4,135.1,22.9,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.5,140.8c-0.7-0.6-1.3-1.1-2-1.7C27.2,139.7,27.8,140.3,28.5,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.6,74.8c0-0.9-0.1-1.8-0.2-2.8C370.5,73,370.6,73.9,370.6,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.8,79.7c0-1.3,0-2.6-0.1-3.9C370.8,77.1,370.8,78.4,370.8,79.7c0,58.3,16,79.6,16,79.6l8.6,10.9l-8.6-10.9 C386.8,159.3,370.8,138,370.8,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.4,44.1l-0.4-0.8L362.4,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.4,50.7c-0.1-0.4-0.3-0.8-0.5-1.2C365,49.9,365.2,50.3,365.4,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.9,47.3c-0.1-0.4-0.3-0.7-0.5-1C363.6,46.6,363.8,47,363.9,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.6,54.2c-0.2-0.5-0.3-0.9-0.5-1.4C366.3,53.2,366.4,53.7,366.6,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.7,40.9l-0.2-0.4L360.7,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.3,158.5c-1.1-0.2-2.2-0.4-3.3-0.6C65.1,158.1,66.2,158.3,67.3,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,157.8c-1.1-0.2-2.2-0.5-3.2-0.7C61.2,157.3,62.2,157.6,63.4,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.4,156.9c-1.1-0.3-2.1-0.6-3.2-0.9C57.3,156.3,58.4,156.6,59.4,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.7,159.5c-1.3,0-2.5,0-3.8-0.1C77.1,159.4,78.4,159.5,79.7,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.6,155.8c-1.1-0.3-2.1-0.7-3.1-1.1C53.5,155.1,54.6,155.4,55.6,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,159c-1.1-0.1-2.3-0.3-3.4-0.4C69.1,158.8,70.2,158.9,71.4,159z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,159.4c-1.2-0.1-2.4-0.2-3.6-0.3C73.1,159.2,74.3,159.3,75.5,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,143.3c-0.8-0.6-1.5-1.2-2.2-1.8C30,142.1,30.8,142.7,31.5,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,147.7c-0.8-0.5-1.6-1-2.4-1.6C36.4,146.7,37.2,147.2,38,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.4,149.7c-0.9-0.5-1.7-1-2.6-1.5C39.7,148.7,40.6,149.2,41.4,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.9,154.5c-1-0.4-2-0.8-2.9-1.2C50,153.7,51,154.1,51.9,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.7,145.5c-0.8-0.5-1.6-1.1-2.3-1.7C33.1,144.5,33.9,145,34.7,145.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.4,153.1c-0.9-0.4-1.9-0.8-2.8-1.3C46.5,152.3,47.5,152.7,48.4,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,151.5c-0.9-0.5-1.9-0.9-2.8-1.4C43.1,150.6,44,151.1,45,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.1,159.5H79.7c-1.3,0-2.5,0-3.8-0.1h-0.4c-1.2-0.1-2.4-0.2-3.6-0.3l-0.6-0.1c-1.1-0.1-2.3-0.3-3.4-0.4 l-0.6-0.1c-1.1-0.2-2.2-0.4-3.3-0.6l-0.7-0.1c-1.1-0.2-2.2-0.5-3.2-0.7l-0.7-0.2c-1.1-0.3-2.1-0.6-3.2-0.9l-0.6-0.2 c-1.1-0.3-2.1-0.7-3.1-1.1l-0.5-0.2c-1-0.4-2-0.8-2.9-1.2l-0.6-0.2c-0.9-0.4-1.9-0.8-2.8-1.3l-0.6-0.3c-0.9-0.5-1.9-0.9-2.8-1.4 l-0.8-0.4c-0.9-0.5-1.7-1-2.6-1.5l-0.8-0.5c-0.8-0.5-1.6-1-2.4-1.6c-0.3-0.2-0.6-0.4-0.9-0.6c-0.8-0.5-1.6-1.1-2.3-1.7l-0.9-0.6 c-0.8-0.6-1.5-1.2-2.2-1.8c-0.3-0.2-0.5-0.4-0.8-0.7c-0.7-0.6-1.3-1.1-2-1.7l-0.9-0.8c-0.6-0.6-1.2-1.1-1.8-1.7l-0.9-0.9 c-0.6-0.6-1.2-1.2-1.8-1.8l-0.7-0.8l0,0l13.7,17.2c15.1,17,36.7,26.7,59.4,26.7H305c18.3,0,36.1-6.3,50.3-17.9l-11.6-14.6l-2.3-2.9 C327.2,153.2,309.4,159.5,291.1,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M400.7,176.8l-5.2-6.6l-8.6-10.9c-21.1,0-36.4-9.7-45.4-17.7l2.3,2.9l11.6,14.6c7.5,6.7,16.3,11.7,25.9,14.8 C387.5,175.8,394.1,176.8,400.7,176.8L400.7,176.8L400.7,176.8L400.7,176.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "341.4,141.6 343.7,144.4 341.4,141.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M360.7,40.9c0.4,0.8,0.8,1.6,1.2,2.3l0.4,0.8c0.4,0.7,0.7,1.5,1.1,2.2c0.2,0.4,0.3,0.7,0.5,1 c0.3,0.7,0.6,1.4,0.9,2.1c0.2,0.4,0.3,0.8,0.5,1.2c0.3,0.7,0.5,1.4,0.8,2.1c0.2,0.5,0.3,0.9,0.5,1.4c0.4,1.1,0.7,2.1,1,3.2 c0.2,0.7,0.4,1.4,0.6,2.1c0.1,0.5,0.2,1,0.4,1.5c0.2,0.7,0.3,1.4,0.5,2.1c0.1,0.5,0.2,1,0.3,1.5c0.1,0.7,0.3,1.5,0.4,2.2 c0.1,0.5,0.1,1,0.2,1.5c0.1,0.8,0.2,1.6,0.3,2.4l0.1,1.4c0.1,0.9,0.1,1.8,0.2,2.8c0,0.4,0.1,0.7,0.1,1c0.1,1.3,0.1,2.6,0.1,3.9 c0,58.3,16,79.6,16,79.6l8.6,10.9l5.2,6.6c-0.4-0.6-8.2-11.6-12.7-38.1c-2.3-13.7-3.3-27.6-3.2-41.4c0-16.7-5.2-32.9-15-46.4 l-16.3-20.8l0,0l0.1,0.1c2.6,3.3,5,6.8,7.1,10.5L360.7,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M400.7,176.8L400.7,176.8l-5.2-6.6L400.7,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.9,135.7l0.9,0.9c0.6,0.6,1.2,1.1,1.8,1.7l0.9,0.8c0.7,0.6,1.3,1.2,2,1.7c0.3,0.2,0.5,0.5,0.8,0.7 c0.7,0.6,1.5,1.2,2.2,1.8l0.9,0.6c0.8,0.6,1.5,1.1,2.3,1.7c0.3,0.2,0.6,0.4,0.9,0.6c0.8,0.5,1.6,1.1,2.4,1.6l0.8,0.5 c0.9,0.5,1.7,1,2.6,1.5l0.8,0.4c0.9,0.5,1.8,1,2.8,1.4l0.6,0.3c0.9,0.4,1.9,0.9,2.8,1.3l0.6,0.2c1,0.4,2,0.8,2.9,1.2l0.5,0.2 c1,0.4,2.1,0.7,3.1,1.1l0.6,0.2c1.1,0.3,2.1,0.6,3.2,0.9l0.7,0.2c1.1,0.3,2.1,0.5,3.2,0.7l0.7,0.1c1.1,0.2,2.2,0.4,3.3,0.6l0.6,0.1 c1.1,0.2,2.3,0.3,3.4,0.4l0.6,0.1c1.2,0.1,2.4,0.2,3.6,0.3h0.4c1.2,0,2.5,0.1,3.8,0.1h211.4c18.3,0,36.1-6.3,50.3-17.9l0,0 c9,8,24.3,17.7,45.4,17.7c0,0-16-21.3-16-79.6c0-1.3,0-2.6-0.1-3.9c0-0.4,0-0.7-0.1-1c0-0.9-0.1-1.8-0.2-2.8l-0.1-1.4 c-0.1-0.8-0.2-1.6-0.3-2.4c-0.1-0.5-0.1-1-0.2-1.5c-0.1-0.7-0.2-1.5-0.4-2.2c-0.1-0.5-0.2-1-0.3-1.5c-0.1-0.7-0.3-1.4-0.5-2.1 c-0.1-0.5-0.2-1-0.4-1.5c-0.2-0.7-0.4-1.4-0.6-2.1c-0.3-1.1-0.6-2.1-1-3.2c-0.2-0.5-0.3-0.9-0.5-1.4c-0.3-0.7-0.5-1.4-0.8-2.1 c-0.1-0.4-0.3-0.8-0.5-1.2c-0.3-0.7-0.6-1.4-0.9-2.1c-0.1-0.4-0.3-0.7-0.5-1c-0.3-0.7-0.7-1.5-1.1-2.2l-0.4-0.8 c-0.4-0.8-0.8-1.6-1.2-2.3l-0.2-0.4c-14.1-25-40.6-40.5-69.4-40.6H79.7C35.7,0,0,35.7,0,79.7c0,19.7,7.3,38.7,20.5,53.4l0.7,0.8 C21.8,134.5,22.4,135.1,22.9,135.7z M245.7,52.1l35.4-12.2h1.7v80.7h-18.7V60.9l-18.4,5.4L245.7,52.1z M233.3,81.7 c4,0,7.3,3.3,7.3,7.3s-3.3,7.3-7.3,7.3c-4,0-7.3-3.3-7.3-7.3c0,0,0,0,0,0C225.9,84.9,229.2,81.7,233.3,81.7 C233.3,81.7,233.3,81.7,233.3,81.7L233.3,81.7z M170.4,52.1l35.4-12.2h1.7v80.7h-18.7V60.9l-18.4,5.4V52.1z M161.8,81.7 c4,0,7.3,3.3,7.3,7.3c0,4-3.3,7.3-7.3,7.3c-4,0-7.3-3.3-7.3-7.3C154.5,85,157.7,81.7,161.8,81.7C161.8,81.7,161.8,81.7,161.8,81.7 L161.8,81.7z M87.9,52.1c2.4-4.2,6-7.6,10.3-9.8c4.5-2.4,9.6-3.6,14.7-3.6c8.7,0,15.4,2,20.1,6c4.7,4,7.1,9.8,7.1,17.3 c0,3.2-0.6,6.3-1.8,9.3c-1.4,3.4-3.3,6.6-5.5,9.5c-3.7,4.7-7.8,9.1-12.1,13.3l-10.4,12h31.8v14.4H85.8v-12.1l25.9-27.3 c6.4-7.3,9.6-13.1,9.6-17.4c0-3.5-0.8-6.1-2.3-7.9c-1.7-1.9-4.1-2.9-6.6-2.7c-2.8,0-5.4,1.3-6.9,3.6c-1.8,2.7-2.8,5.8-2.7,9.1H84.2 C84.1,60.9,85.4,56.2,87.9,52.1L87.9,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64,157.9l-0.7-0.1L64,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.3,141.5c-0.3-0.2-0.5-0.4-0.8-0.7C28.8,141,29,141.3,29.3,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.9,159.1l-0.6-0.1L71.9,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49,153.3l-0.6-0.2L49,153.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.5,139.1l-0.9-0.8L26.5,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291.1,159.5L291.1,159.5c18.3,0,36.1-6.3,50.3-17.9l0,0C327.2,153.2,309.4,159.5,291.1,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.9,135.7l0.9,0.9L22.9,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.1,157l-0.7-0.2L60.1,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.4,143.9l-0.9-0.6L32.4,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.6,146.1c-0.3-0.2-0.6-0.4-0.9-0.6C35,145.8,35.3,145.9,35.6,146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.5,154.7l-0.5-0.2L52.5,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.5,133.1l0.7,0.8L20.5,133.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.6,151.8l-0.6-0.3L45.6,151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.2,150.1l-0.8-0.4L42.2,150.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.2,156l-0.6-0.2L56.2,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.9,148.2l-0.8-0.5L38.9,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.9,158.6l-0.6-0.1L67.9,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.9,159.4h-0.4H75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M363.4,46.3c-0.3-0.7-0.7-1.5-1.1-2.2C362.7,44.8,363.1,45.6,363.4,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M367.6,57.4c-0.3-1.1-0.6-2.1-1-3.2C367,55.2,367.3,56.3,367.6,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M362,43.3c-0.4-0.8-0.8-1.6-1.2-2.3C361.1,41.7,361.6,42.5,362,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M368.6,61c-0.1-0.5-0.2-1-0.4-1.5C368.4,60,368.5,60.5,368.6,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M364.8,49.5c-0.3-0.7-0.6-1.4-0.9-2.1C364.2,48,364.5,48.8,364.8,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M366.1,52.8c-0.3-0.7-0.5-1.4-0.8-2.1C365.6,51.4,365.9,52.1,366.1,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M370.4,72.1l-0.1-1.4L370.4,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M353.4,30c2.6,3.3,5,6.8,7.1,10.5C358.4,36.8,356,33.3,353.4,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M370,68.3c-0.1-0.5-0.1-1-0.2-1.5C369.8,67.4,369.9,67.8,370,68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M370.7,75.9c0-0.4,0-0.7-0.1-1C370.7,75.2,370.7,75.5,370.7,75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M369.4,64.6c-0.1-0.5-0.2-1-0.3-1.5C369.2,63.6,369.3,64.1,369.4,64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.6,56.7c1.5-2.3,4.2-3.7,6.9-3.6c2.5-0.2,4.9,0.8,6.6,2.7c1.5,1.8,2.3,4.5,2.3,7.9 c0,4.3-3.2,10.1-9.6,17.4l-25.9,27.3v12.2h56.3v-14.4h-31.8l10.4-12c4.3-4.2,8.3-8.6,12.1-13.3c2.3-2.9,4.1-6.1,5.5-9.5 c1.2-3,1.8-6.1,1.8-9.3c0-7.5-2.4-13.3-7.1-17.4s-11.4-6-20.1-6c-5.1-0.1-10.2,1.1-14.7,3.6c-4.3,2.3-7.9,5.7-10.3,9.8 c-2.5,4.1-3.8,8.9-3.7,13.7h18.7C102.8,62.6,103.7,59.4,105.6,56.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "188.8,120.5 207.5,120.5 207.5,39.8 205.8,39.8 170.4,52.1 170.4,66.3 188.8,60.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "264.1,120.5 282.8,120.5 282.8,39.8 281.1,39.8 245.7,52.1 245.7,66.3 264.1,60.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M161.8,96.3c4,0,7.3-3.3,7.3-7.3s-3.3-7.3-7.3-7.3c-4,0-7.3,3.3-7.3,7.3c0,0,0,0,0,0 C154.5,93,157.8,96.3,161.8,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.3,96.3c4,0,7.3-3.3,7.3-7.3s-3.3-7.3-7.3-7.3s-7.3,3.3-7.3,7.3c0,0,0,0,0,0 C225.9,93,229.2,96.3,233.3,96.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.4,234.9h-7.6l-14.7-24.1v24.1h-7.5v-36.6h7.5l14.7,24.2v-24.2h7.5V234.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.1,235.4c-3.6,0.1-7.1-1.2-9.7-3.7c-2.6-2.6-3.9-6.1-3.8-9.8v-0.7c0-2.5,0.5-5,1.6-7.3 c1-2.1,2.5-3.8,4.5-5c2-1.2,4.3-1.8,6.6-1.7c3.3-0.2,6.5,1.1,8.8,3.5c2.3,2.8,3.5,6.4,3.2,10v3h-17.4c0.2,1.6,0.9,3.2,2.1,4.3 c1.2,1.1,2.8,1.7,4.5,1.6c2.6,0.1,5-1,6.6-3l3.6,4c-1.1,1.6-2.7,2.8-4.4,3.6C121.3,235,119.2,235.4,117.1,235.4z M116.3,213 c-1.3,0-2.6,0.5-3.5,1.5c-1,1.2-1.6,2.7-1.7,4.2h10.1v-0.6c0.1-1.4-0.4-2.7-1.3-3.8C118.9,213.4,117.6,212.9,116.3,213L116.3,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156.1,225l3.6-17.3h7l-6.9,27.2h-6.1l-5.1-17.1l-5.1,17.1h-6l-7-27.2h7l3.5,17.3l5-17.3h5.2L156.1,225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M198.4,198.2h7.6v25.4c0,2.2-0.5,4.3-1.5,6.2c-1,1.8-2.5,3.2-4.4,4.1c-2,1-4.2,1.5-6.4,1.5 c-3.3,0.2-6.5-0.8-9.1-2.9c-2.2-2.2-3.4-5.2-3.2-8.4h7.6c-0.1,1.4,0.3,2.8,1.1,4c0.9,0.9,2.3,1.4,3.6,1.3c1.3,0,2.6-0.5,3.4-1.5 c0.9-1.2,1.4-2.7,1.3-4.2V198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.5,235.4c-3.6,0.1-7.1-1.2-9.8-3.7c-2.6-2.6-3.9-6.1-3.8-9.8v-0.7c0-2.5,0.5-5,1.6-7.3 c1-2.1,2.6-3.8,4.5-5c2-1.2,4.3-1.8,6.6-1.7c3.3-0.2,6.5,1.1,8.8,3.5c2.3,2.8,3.4,6.4,3.2,10v3h-17.3c0.2,1.6,0.9,3.2,2.1,4.3 c1.2,1.1,2.8,1.7,4.5,1.6c2.6,0.1,5-1,6.6-3l3.6,4c-1.1,1.6-2.7,2.8-4.4,3.6C228.7,235,226.6,235.4,224.5,235.4z M223.6,213 c-1.3,0-2.6,0.5-3.5,1.5c-1,1.2-1.6,2.7-1.7,4.2h10.1v-0.6c0.1-1.4-0.4-2.7-1.3-3.8C226.3,213.4,225,212.9,223.6,213L223.6,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M255.1,214.5c-0.9-0.1-1.7-0.2-2.6-0.2c-2.7,0-4.6,0.9-5.4,2.8v17.8h-7.3v-27.2h6.9l0.2,3.2 c1.1-2.3,3.5-3.8,6.1-3.8c0.8,0,1.5,0.1,2.3,0.3L255.1,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M273.3,227.4c0-0.9-0.5-1.7-1.3-2.1c-1.3-0.7-2.8-1.1-4.3-1.4c-6.5-1.4-9.7-4.1-9.7-8.3c0-2.4,1.1-4.6,3-6.1 c2.3-1.7,5-2.6,7.9-2.4c3-0.1,5.9,0.7,8.3,2.5c2,1.5,3.2,3.9,3.1,6.3h-7.3c0-1-0.3-1.9-1-2.6c-0.9-0.7-2-1.1-3.2-1 c-1-0.1-2,0.2-2.8,0.8c-0.6,0.5-1,1.3-1,2.1c0,0.8,0.4,1.5,1.1,1.9c1.2,0.7,2.5,1.1,3.9,1.3c1.6,0.3,3.1,0.7,4.6,1.2 c3.8,1.4,5.8,3.9,5.8,7.3c0,2.4-1.2,4.7-3.2,6c-2.4,1.6-5.3,2.4-8.3,2.3c-2.1,0-4.2-0.4-6.1-1.2c-1.7-0.7-3.1-1.9-4.2-3.3 c-1-1.3-1.5-2.9-1.5-4.6h6.9c0,1.2,0.5,2.2,1.4,3c1,0.7,2.3,1.1,3.6,1c1.1,0.1,2.2-0.2,3.2-0.8C272.9,229,273.4,228.2,273.3,227.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M297.6,235.4c-3.6,0.1-7.1-1.2-9.7-3.7c-2.6-2.6-3.9-6.1-3.8-9.8v-0.7c0-2.5,0.5-5,1.6-7.3 c1-2.1,2.5-3.8,4.5-5c2-1.2,4.3-1.8,6.6-1.7c3.3-0.2,6.5,1.1,8.8,3.5c2.3,2.8,3.4,6.4,3.2,10v3h-17.4c0.2,1.6,0.9,3.2,2.1,4.3 c1.2,1.1,2.8,1.7,4.5,1.6c2.6,0.1,5-1,6.6-3l3.6,4c-1.1,1.6-2.7,2.8-4.4,3.6C301.9,235,299.8,235.4,297.6,235.4z M296.8,213 c-1.3,0-2.6,0.5-3.5,1.5c-1,1.2-1.6,2.7-1.7,4.2h10.1v-0.6c0.1-1.4-0.4-2.7-1.3-3.8C299.5,213.4,298.2,212.9,296.8,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M322.8,224.6l5-16.9h7.8l-11,31.5l-0.6,1.4c-1.3,3.3-4.5,5.5-8.1,5.3c-1.1,0-2.2-0.2-3.2-0.5v-5.5h1.1 c1.1,0.1,2.1-0.2,3.1-0.6c0.7-0.5,1.3-1.2,1.6-2.1l0.9-2.2l-9.5-27.3h7.8L322.8,224.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNj211);
export default __webpack_public_path__ + "static/media/nj211.df3a949ba17478fd5706cd1c85223201.svg";
export { ForwardRef as ReactComponent };